var map = {
	"./01_white_dance.gif": "bb445",
	"./01_white_talk.gif": "914f",
	"./02_yellow_dance.gif": "1df2",
	"./02_yellow_talk.gif": "3946",
	"./02yellow.gif": "3b61",
	"./03_orange_dance.gif": "7780",
	"./03_orange_talk.gif": "3352",
	"./03orange.gif": "3092",
	"./04_green_dance.gif": "9164",
	"./04_green_talk.gif": "8e2d",
	"./04green.gif": "71b1",
	"./05_blue_dance.gif": "da5c",
	"./05_blue_talking.gif": "288d",
	"./05blue.gif": "6718",
	"./06black.gif": "f05d",
	"./A_TalkBeforeAction.gif": "753f",
	"./A_action.png": "a408",
	"./A_illustration.gif": "6a2c",
	"./A_talk.gif": "f006",
	"./BG_blue.gif": "c8bb2",
	"./BG_blue.png": "c7df",
	"./BG_green.gif": "4a04",
	"./BG_green.png": "f6bf",
	"./BG_orange.gif": "7b31",
	"./BG_orange.png": "7109",
	"./BG_white.gif": "8719",
	"./BG_white.png": "a1b3",
	"./BG_yellow.gif": "4781",
	"./BG_yellow.png": "f579",
	"./E_TalkBeforeAction.gif": "6c92",
	"./E_action.png": "b48d",
	"./E_illustration.gif": "34c5",
	"./E_talk.gif": "d216",
	"./FinishGameTalk.gif": "2778",
	"./I_TalkBeforeAction.gif": "15a8",
	"./I_action.png": "bbd0",
	"./I_illustration.gif": "c6da",
	"./I_talk.gif": "dc9a",
	"./O_TalkBeforeAction.gif": "37bb",
	"./O_action.png": "94ae",
	"./O_illustration.gif": "d2aa",
	"./O_talk.gif": "1f23",
	"./Shva_TalkBeforeAction.gif": "10d7",
	"./Shva_action.png": "dfbc",
	"./Shva_illustration.gif": "60b6",
	"./Shva_talk.gif": "762b",
	"./U_TalkBeforeAction.gif": "2e41",
	"./U_action.png": "15f9",
	"./U_illustration.gif": "23ea",
	"./U_talk.gif": "a071",
	"./background_blue.png": "6654",
	"./background_green.png": "1266",
	"./background_orange.png": "3e72",
	"./background_white.png": "0b66",
	"./background_yellow.png": "b202",
	"./belt_center_pointer.gif": "fbcd",
	"./belt_center_talk.gif": "92a7",
	"./bg 01 white.png": "2794",
	"./bg 02 yellow.png": "8c0c",
	"./bg 03 orange.png": "db17",
	"./bg 04 green.png": "9463",
	"./bg 05 blue.png": "d04c",
	"./bg-1.png": "79c1",
	"./bg-2.png": "7c80",
	"./bg-3.png": "27cf",
	"./bg-4.png": "ee68",
	"./bg-5.png": "cee4",
	"./bg.png": "16b0c",
	"./bg_final.png": "9c3a",
	"./black_belt_center.gif": "e9ce",
	"./black_belt_move.gif": "60b5",
	"./black_lock.gif": "0d1c",
	"./black_talk.gif": "cadf7",
	"./black_unlock.gif": "c43e",
	"./blue_dance.png": "1cff",
	"./blue_lock.gif": "ead2",
	"./blue_talk.gif": "bbc9",
	"./blue_unlock.gif": "45d1",
	"./center_talk.gif": "e8b4",
	"./final_center_talk.gif": "3727",
	"./green_dance.png": "1b31",
	"./green_lock.gif": "5f10",
	"./green_talk.gif": "d59b",
	"./green_unlock.gif": "44be",
	"./jump.gif": "4067",
	"./level_center_pointer.gif": "0adad",
	"./level_center_pointer.png": "ff1c",
	"./level_center_talk.gif": "fd8f",
	"./numbers.gif": "0d41",
	"./orange_dance.png": "2581",
	"./orange_lock.gif": "677b",
	"./orange_talk.gif": "79a1",
	"./orange_unlock.gif": "245f",
	"./skip.png": "7e0f",
	"./skip_hover.png": "c2f8",
	"./talk-fullbody.gif": "ccbf",
	"./talk-o.gif": "806b8",
	"./white_dance.png": "357f",
	"./yellow_dance.png": "c595",
	"./yellow_lock.gif": "9c57",
	"./yellow_talk.gif": "e26a",
	"./yellow_unlock.gif": "7387"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "13d7";